import { ProfileMedia } from "../../types/coreApiMirror";
import { getClassName } from "@pairtreefamily/utils";
import GalleryTile from "./galleryTile";
import Image from "next/image";

export type MediaProps = ProfileMedia & {
  type: "video" | "photo";
  onClick: () => void;
};

export function Media(props: MediaProps) {
  const labelID = `${props.media_url}-label`;
  return (
    <div
      onClick={props.onClick}
      role="button"
      className="relative h-full min-h-[480px] w-full"
    >
      <Image
        width={900}
        height={900}
        aria-labelledby={labelID}
        src={props.media_url}
        alt={props.description ?? ""}
        className="h-full w-full object-cover hover:scale-[1.02]"
        sizes="max-width: 1024px, 100vw, 50vw"
        loading="lazy"
      />
      {props.description && (
        <div
          className={getClassName(
            "p-5 opacity-0 transition-opacity duration-300 hover:opacity-100",
            "absolute left-0 top-0 h-full w-full bg-green",
            "flex items-center justify-center ",
          )}
        >
          <p id={labelID} className="text-body-1 text-white">
            {props.description}
          </p>
        </div>
      )}
    </div>
  );
}

export function LargeMediaTile(props: {
  media: ProfileMedia;
  onMediaClick: () => void;
}) {
  return (
    <GalleryTile className="cursor-pointer p-0" size="lg">
      <Media {...props.media} onClick={props.onMediaClick} type="photo" />
    </GalleryTile>
  );
}

export function SmallMediaTile(props: {
  media: ProfileMedia;
  onMediaClick: () => void;
}) {
  return (
    <GalleryTile className="cursor-pointer p-0" size="sm">
      <Media {...props.media} onClick={props.onMediaClick} type="photo" />
    </GalleryTile>
  );
}

export default Media;
